import { toast } from "react-toastify";

export function ErrorToast(e: any) {
 
  const callbackMsg = "Something went wrong";
  
  // Check for different error formats
  let errorMessages;
  
  if (e?.response?.data?.message) {
    // API error with response data
    errorMessages = e.response.data.message;
  } else if (e?.message) {
    // Standard error object with message property
    errorMessages = e.message;
  } else if (typeof e === 'string') {
    // String error
    errorMessages = e;
  } else {
    // Fallback
    errorMessages = callbackMsg;
  }
  
  const isMessageArray = Array.isArray(errorMessages);
  if (isMessageArray) {
    errorMessages.forEach((errorMessage: string) => {
      if (errorMessage?.length) {
        toast.error(errorMessage, { autoClose: 3000 });
      }
    });
  } else {
    toast.error(errorMessages, {
      autoClose: 3000,
    });
  }
}
export function ErrorToastFileTranslate(props: string) {
  toast.error(props, { autoClose: 3000 });
}

export function SuccessToast(props: string) {
  toast.success(props, { autoClose: 3000 });
}

export function WarningToast(props: string) {
  toast.warning(props, { autoClose: 3000 });
}

const isErrorArray = (args: string[]) => {
  return Array.isArray(args);
};
// toast.success(props, { autoClose: 5000 je default });
